import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noOptionsMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedFetch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allEpics: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'issue-field-epic-link.edit.placeholder',
		defaultMessage: 'Select Epic',
		description: '',
	},
	noOptionsMessage: {
		id: 'issue-field-epic-link.edit.no-options-message',
		defaultMessage: 'No matches found',
		description: 'Message when no options are found in a select',
	},
	failedFetch: {
		id: 'issue-field-epic-link.edit.failed-fetch',
		defaultMessage: 'Search failed. Please try again.',
		description: 'Message when fetching suggestions fails',
	},
	loadingMessage: {
		id: 'issue-field-epic-link.edit.loading-message',
		defaultMessage: 'Searching...',
		description: 'Message showed when options are being loaded from the server.',
	},
	allEpics: {
		id: 'issue-field-epic-link.edit.all-epics',
		defaultMessage: 'All epics',
		description: 'Label for the group containing all of the epics',
	},
});
export default messages;
